import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import request from "./utils/request";
import storage from "./utils/storage";

Vue.config.productionTip = false;
Vue.prototype.$http = request;
Vue.prototype.$storage = storage;

Object.defineProperty(Vue.prototype, '$prefix', {
  get() {
    // 这样每次调用 this.$prefix 都会实时去路由里找
    return this.$route.params.prefix?`/${this.$route.params.prefix}/`:'/';
  }
});

Vue.prototype.back = function (route) {
  if (window.history.length > 1) {
    this.$router.back();
  } else {
    this.$router.replace(route);
  }
};

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
